

export default {
    ID: 0,
    version: '1.0.0',
    name: 'test',
    title: 'Test',
    excerpt: 'Test application',
    content: {
        workbooks: [],
        forms: []
    }, 
    meta_input: {
        color: '#FFFFFF'
    }
}


